export const THEME_STORAGE_KEY = 'mykol_theme_dark';

export function applyTheme(dark: boolean) {
  document.documentElement.classList.toggle('dark', dark);
  document.documentElement.dataset.theme = dark ? 'dark' : 'light';
  localStorage.setItem(THEME_STORAGE_KEY, dark ? '1' : '0');
  document.querySelectorAll('[data-portal-shell]').forEach((el) => {
    (el as HTMLElement).dataset.theme = dark ? 'dark' : 'light';
  });
}

export function readStoredTheme(): boolean {
  return localStorage.getItem(THEME_STORAGE_KEY) === '1';
}
